export default {
    keyfobs_create_new_driver_key: "Nueva llave del conductor",
    keyfobs_create_edit_driver_key: "Editar la clave del conductor",
    keyfobs_create_success_message: "Se ha creado la clave del conductor",
    keyfobs_update_success_message: "La clave del conductor ha sido editada",
    keyfobs_account: "Cuenta",
    keyfobs_identifier: "Identificador",
    keyfobs_driver: "Conductor",
}